module.exports = __webpack_public_path__ + "static/media/liveroom-setting-manage.8f950d1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/liveroomSetting/liveroom-setting-manage.png
// module id = 2065
// module chunks = 4